import React, { useState, useEffect } from 'react';
import {
  Box, TextField, FormControl, InputLabel, Select, MenuItem, Typography, Grid, Autocomplete, Button
} from '@mui/material';
import {
  tiposCargas, tiposServicos, enquadramentos, deparaTecnologiasSistemasTomadaPreco, deparaServicosSistemasTomadaPreco,
} from "../../static";
import api from "../../services/api";
import { useStoreState, useStoreActions } from 'easy-peasy';

import AddTomadaFaseOne from "./AddTomada/AddTomadaFaseOne";

export default function AddTomadaPreco({ currProcesso, onClose }) {
  const loading = useStoreState((state) => state.nav.loading);
  const startLoading = useStoreActions((actions) => actions.nav.startLoading);
  const stopLoading = useStoreActions((actions) => actions.nav.stopLoading);

  const [enquadramento, setEnquadramento] = useState('');
  const [finishedAt, setFinishedAt] = useState('');
  const [errorMessageData, setErrorMessageData] = useState("");
  const [errorMessageTipos, setErrorMessageTipos] = useState("");
  const [tiposSelecionados, setTiposSelecionados] = useState([[], []]);
  const [dadosTecnologias, setDadosTecnologias] = useState(() => {
    const initialData = {};
    [...tiposSelecionados[0], ...tiposSelecionados[1]].forEach((item) => {
      initialData[item.id] = [];
    });
    return initialData;
  });

  const [qtdFornecedores, setQtdFornecedores] = useState(null);

  useEffect(() => {
    const fetchCount = async () => {
      const slugs = [...tiposSelecionados[0], ...tiposSelecionados[1]].map(t => t.id);
      if (slugs.length === 0) {
        setQtdFornecedores(0);
        return;
      }
      try {
        const response = await api.http.get('/fornecedores/count-matching', {
          params: {
            enquadramento,
            slugs: slugs.join(','),
          }
        });
        setQtdFornecedores(response.data.count);
      } catch (error) {
        console.error("Erro ao buscar quantidade de fornecedores", error);
      }
    };

    fetchCount();
  }, [enquadramento, tiposSelecionados]);

  const handleChangeEnquadramento = (event) => {
    const newEnquadramento = event.target.value;
    setEnquadramento(newEnquadramento);
    setTiposSelecionados([[], []]);
    setDadosTecnologias({});
  };

  function getTiposTecnologia(enquadramento) {
    if (enquadramento === "fornecedor_de_equipamentos_e_maquinas") return tiposCargas;
    if (enquadramento === "fornecedor_de_servicos") return tiposServicos;
    if (enquadramento === "esco") return [...tiposCargas, ...tiposServicos];
    return [];
  }

  const tiposTecnologia = getTiposTecnologia(enquadramento);

  const verifyDate = () => {
    if (!finishedAt) {
      setErrorMessageData("A data é obrigatória!");
      return false;
    }
  
    const selectedDate = new Date(finishedAt + "T00:00:00").getTime();
    const currentDate = new Date().setHours(0, 0, 0, 0);
  
    if (selectedDate < currentDate) {
      setErrorMessageData("A data não pode ser anterior à atual!");
      return false;
    }
  
    setErrorMessageData(""); 
    return true;
  };
  
  const verifyTipos = () => {
    if (tiposSelecionados.length === 0) {
      setErrorMessageTipos("Selecione pelo menos um tipo de tecnologia ou serviço!");
      return false;
    }
  
    setErrorMessageTipos(""); 
    return true;
  };
  
  const handleSave = async () => {
    if (!finishedAt) {
      setErrorMessageData("A data é obrigatória!");
      return;
    }
    if (verifyDate() === false) return;
    if (verifyTipos() === false) return;

    const tipoIds = {
      tecnologias: [],
      servicos: [],
    };
    const dadosById = {
      tecnologias: {},
      servicos: {},
    };

    tiposSelecionados[0].forEach(({ id: slug }) => {
      const tecArr = deparaTecnologiasSistemasTomadaPreco[slug] || [];
      if (tecArr.length) {
        const numericId = tecArr[0].A;
        tipoIds.tecnologias.push(numericId);
    
        dadosById.tecnologias[numericId] = {
          tabela: dadosTecnologias[slug]?.[0] || {},
          label: slug,
        };
      } else {
        console.warn(`Sem depara para a tecnologia "${slug}"`);
      }
    });
    
    tiposSelecionados[1].forEach(({ id: slug }) => {
      const servArr = deparaServicosSistemasTomadaPreco[slug] || [];
      if (servArr.length) {
        const numericId = servArr[0].S;
        tipoIds.servicos.push(numericId);
    
        dadosById.servicos[numericId] = {
          tabela: {
            coluna1: '',
            ...dadosTecnologias[slug]?.[0],
          },
          label: slug,
        };
      } else {
        console.warn(`Sem depara para o serviço "${slug}"`);
      }
    });
    
    const payload = {
      processoId: currProcesso.id,
      finishedAt,
      enquadramento,
      tiposSelecionados: tipoIds,
      dadosTecnologias: dadosById,
    };
  
    startLoading();
    try {
      await api.http.post('/fornecedores/orcamentosprocessos', payload);
      stopLoading();
      onClose();
    } catch (error) {
      stopLoading({ message: error.toString(), severity: 'error' });
    }
  };

  const handleRemoveTipo = (slug) => {
    setTiposSelecionados(([tecSel, servSel]) => {
      const newTec = tecSel.filter(t => t.id !== slug);
      const newServ = servSel.filter(t => t.id !== slug);
      return [newTec, newServ];
    });
    setDadosTecnologias(prev => {
      const copy = { ...prev };
      delete copy[slug];
      return copy;
    });
  };
  
  
  const updateDadosTecnologia = (tipoId, dados) => {
    setDadosTecnologias((prev) => ({
      ...prev,
      [tipoId]: dados
    }));
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="body1">Tomada de Preço - Processo {currProcesso?.razaoSocial}</Typography>

      <Grid container spacing={1}>
        <Grid item xs={3}>
          <TextField
            fullWidth
            label="Data de encerramento da tomada de preços"
            type="date"
            value={finishedAt}
            onChange={(e) => setFinishedAt(e.target.value)}
            onBlur={verifyDate}
            InputLabelProps={{ shrink: true }}
            sx={{ mt: 2 }}
            error={!!errorMessageData}
            helperText={errorMessageData}
          />
        </Grid>

        <Grid item xs={3}>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Enquadramento</InputLabel>
            <Select value={enquadramento} onChange={handleChangeEnquadramento} label="Enquadramento">
              {enquadramentos.map((enquad) => (
                <MenuItem key={enquad.id} value={enquad.id}>
                  {enquad.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={6}>
        <Autocomplete
          multiple
          options={tiposTecnologia}
          getOptionLabel={(option) => option.label}
          value={[...tiposSelecionados[0], ...tiposSelecionados[1]]}
          onChange={(e, value) => {
            const tecnologias = value.filter(tipo => tiposCargas.some(carga => carga.id === tipo.id));
            const servicos = value.filter(tipo => tiposServicos.some(servico => servico.id === tipo.id));
            setTiposSelecionados([tecnologias, servicos]);

            const updateDados = () => {
              value.forEach((item) => {
                if (!dadosTecnologias[item.id]) {
                  updateDadosTecnologia(item.id, []);
                }
              });
            };
            updateDados(); 
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Tipos"
              placeholder="Selecione..."
              sx={{ mt: 2 }}
              onBlur={verifyTipos}
              error={!!errorMessageTipos}
              helperText={errorMessageTipos}
            />
          )}
        />
        </Grid>
      </Grid>

      {qtdFornecedores !== null && [...tiposSelecionados[0], ...tiposSelecionados[1]].length > 0 && (
        <Box sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            {enquadramento === 'esco' ? (
              `Quantidade de fornecedores ESCO disponíveis: ${qtdFornecedores}`
            ) : (
              `Quantidade de fornecedores disponíveis: ${qtdFornecedores}`
            )}
          </Typography>
        </Box>
      )}

      {[...tiposSelecionados[0], ...tiposSelecionados[1]].map((tipo) => {
        const titulo = tipo.label || tipo.id;
        return (
          <Box key={tipo.id} sx={{ mt: 4 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>{titulo}</Typography>
            <AddTomadaFaseOne
              tipo={tipo.id}
              currProcesso={currProcesso}
              onClose={onClose}
              datamaxima={finishedAt}
              onDataChange={(dados) => updateDadosTecnologia(tipo.id, dados)}
              onRemove={() => handleRemoveTipo(tipo.id)}
            />
          </Box>
        );
      })}

      <Button
        variant="contained"
        color="primary"
        sx={{ mt: 3 }}
        onClick={handleSave}
        disabled={loading}
      >
        Salvar
      </Button>
    </Box>
  );
}
